var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.82 256.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:7px;}.cls-3{fill:#329e51;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.32 253.18 3.5 253.18 3.5 3.5 154.57 3.5 181.32 39.69 181.32 253.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "132.72 2.41 133.2 58.16 182.97 58.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_571",
    className: "cls-3",
    d: "m91.12,178.67h2.79c14.95,0,27.07,12.12,27.07,27.07h0c0,14.95-12.12,27.07-27.07,27.07h-2.79c-14.95,0-27.07-12.12-27.07-27.07h0c0-14.95,12.12-27.07,27.07-27.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    className: "cls-1",
    d: "m86.91,218.25l-11.35-11.35c-.68-.68-.68-1.79,0-2.47,0,0,0,0,0,0l2.47-2.47c.68-.68,1.79-.68,2.47,0,0,0,0,0,0,0l7.65,7.66,16.38-16.38c.68-.68,1.79-.68,2.47,0,0,0,0,0,0,0l2.47,2.47c.68.68.68,1.79,0,2.47,0,0,0,0,0,0l-20.09,20.08c-.68.68-1.79.68-2.47,0,0,0,0,0,0,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.70d9d6553ab959a8e5c9d244c77a41bc.svg";
export { ForwardRef as ReactComponent };